import { createRoot } from "react-dom/client";
import App from "./App";
import { ensureMsalInitialized } from "./auth/msalClient";
import { BrandIconFilterDefinition } from "./components/BrandIcon";
import { applyInitialTheme } from "./hooks/useThemePreference";
import "./overrides.css";

applyInitialTheme();

// Set Excalidraw asset path for fonts (self-hosted from public/)
(window as unknown as Record<string, string>).EXCALIDRAW_ASSET_PATH = "/";

// Initialize MSAL before rendering (handles redirect promise)
// NOTE: StrictMode intentionally omitted — its dev-mode double-mount breaks
// Excalidraw's internal canvas-offset tracking (causes shape ↔ selection misalignment).
ensureMsalInitialized().then(() => {
  createRoot(document.getElementById("root")!).render(
    <>
      <BrandIconFilterDefinition />
      <App />
    </>,
  );
});
